import Link from 'next/link'
import type { FinderFridge } from '@/lib/filters/finder'

/** Ambiguity is an identity question, never evidence that no filter fits. */
export function FilterApplianceChoices({ candidates, truncated }: { candidates: FinderFridge[]; truncated: boolean }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5">
      <h3 className="text-base font-bold text-gray-900">Confirm your refrigerator model</h3>
      <p className="mt-2 text-sm text-gray-700">
        This lookup does not identify one appliance. Compare the complete model and brand with the label inside your refrigerator before choosing a filter.
        {truncated && ' Only some matching appliances are shown. Enter more of the model number to narrow the lookup.'}
      </p>
      <ul className="mt-3 space-y-2">
        {candidates.map(candidate => {
          const finDigits = /-fin(\d{7})$/i.exec(candidate.seo_slug ?? '')?.[1]
          return (
          <li key={candidate.id} className="text-sm text-gray-900">
            {candidate.path ? (
              <Link href={candidate.path} className="inline-flex min-h-11 items-center font-semibold text-[#0469f0] underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
                {candidate.brand} {candidate.model ?? candidate.title}
              </Link>
            ) : <span>{candidate.brand} {candidate.model ?? candidate.title}</span>}
            {finDigits && <p className="text-xs text-gray-600">FIN-{finDigits}</p>}
          </li>
          )
        })}
      </ul>
      <p className="mt-2 text-sm text-gray-700">No filters have been recommended for this ambiguous lookup.</p>
    </div>
  )
}
